import { AppBar, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControlLabel, IconButton, Toolbar, Typography } from "@mui/material";
import MenuIcon from '@mui/icons-material/Menu';
import { useTranslation } from "react-i18next";
import { useRef, useState } from "react";


interface IProps {
    handleDrawerToggle: () => void;
}

export default function Header({handleDrawerToggle}: IProps) {
    const { t } = useTranslation();
    const [openLogout, setOpenLogout] = useState(false);
    const ssoLogoutRef = useRef<HTMLInputElement>(null);
    
    const handleLogout = () => {
        if (ssoLogoutRef.current?.checked) {
            let url = process.env.REACT_APP_LOGOUT_URL ?? "http://localhost:3001/logout";
            url += "?redirect=" + encodeURIComponent(process.env.REACT_APP_LOGOUT_REDIRECT_URL ?? "http://localhost:3000/logout");
            document.location.href = url;
        } else {
            localStorage.removeItem('isLogin');
            localStorage.removeItem('rezvan_token');
            document.location.href = '/';
        }
    }

    const handleOpenLogoutDialog = () => {
        setOpenLogout(true);
    }

    const handleCloseLogoutDialog = () => {
        setOpenLogout(false);
    }

    return (
        <AppBar position="sticky" sx={{ zIndex: { sm: 1201 } }}>
            <Toolbar>
                <IconButton
                    size="large"
                    edge="start"
                    color="inherit"
                    aria-label="menu"
                    sx={{ mr: 2 }}
                    onClick={handleDrawerToggle}
                >
                    <MenuIcon />
                </IconButton>
                <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                    {t('app_name')}
                </Typography>
                <Button onClick={handleOpenLogoutDialog}color="inherit">{t('signout')}</Button>
            </Toolbar>
            <Dialog open={openLogout} onClose={handleCloseLogoutDialog}>
                <DialogTitle>{t('logout_from_account')}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {t('logout_description')}
                    </DialogContentText>
                    <FormControlLabel control={<Checkbox inputRef={ssoLogoutRef} defaultChecked />} label={t('also_logout_sso')} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseLogoutDialog}>{t('cansle')}</Button>
                    <Button variant="contained" onClick={handleLogout}>{t('signout')}</Button>
                </DialogActions>
            </Dialog>
        </AppBar>
    )
}
